import React from 'react';

interface CustomIconProps {
  width?: string;
}

const GiftIcon: React.FC<CustomIconProps> = ({ width }) => (
  <svg
    width={width ?? '20'}
    height={width ?? '20'}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M16.667 5.83073H15.6595C15.7817 5.42555 15.8405 5.00389 15.8337 4.58073C15.8337 2.9724 14.5253 1.66406 12.917 1.66406C11.5653 1.66406 10.6628 2.89906 10.0803 4.2349C9.50616 2.9724 8.55783 1.66406 7.08366 1.66406C5.47533 1.66406 4.16699 2.9724 4.16699 4.58073C4.16699 5.0774 4.23283 5.48823 4.34116 5.83073H3.33366C2.41449 5.83073 1.66699 6.57823 1.66699 7.4974V9.16406C1.66699 10.0832 2.41449 10.8307 3.33366 10.8307V16.6641C3.33366 17.5832 4.08116 18.3307 5.00033 18.3307H15.0003C15.9195 18.3307 16.667 17.5832 16.667 16.6641V10.8307C17.5862 10.8307 18.3337 10.0832 18.3337 9.16406V7.4974C18.3337 6.57823 17.5862 5.83073 16.667 5.83073ZM12.917 3.33073C13.6062 3.33073 14.167 3.89156 14.167 4.58073C14.167 5.83073 13.6453 5.83073 13.3337 5.83073H11.2687C11.6945 4.5174 12.3128 3.33073 12.917 3.33073ZM5.83366 4.58073C5.83366 3.89156 6.39449 3.33073 7.08366 3.33073C7.82366 3.33073 8.51199 4.60156 8.91533 5.83073H6.66699C6.35533 5.83073 5.83366 5.83073 5.83366 4.58073ZM3.33366 7.4974H9.16699V9.16406H3.33366V7.4974ZM5.00033 16.6641V10.8307H9.16699V16.6641H5.00033ZM15.0003 16.6641H10.8337V10.8307H15.0003V16.6641ZM10.8337 9.16406V7.56823L10.8478 7.4974H16.667L16.6678 9.16406H10.8337Z'
      fill='url(#paint0_linear_6608_63411)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_6608_63411'
        x1='10.0003'
        y1='1.66406'
        x2='10.0003'
        y2='18.3307'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#F9742C' />
        <stop offset='1' stopColor='#F20486' />
      </linearGradient>
    </defs>
  </svg>
);

export default GiftIcon;
